module.exports = __webpack_public_path__ + "static/media/wallet_share_income.31f35fd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallet/wallet_share_income.png
// module id = 2076
// module chunks = 6